import { StyleSheet, Text, View } from '@react-pdf/renderer';
import React, { memo } from 'react';
import { withTranslation } from 'react-i18next';
import commonStyles from '../../Common/commonStyles';
const styles = StyleSheet.create({
    elements: Object.assign(Object.assign({}, commonStyles.fontM), { marginHorizontal: commonStyles.marginHorizontal, paddingBottom: '2%', borderBottom: '1.5px solid #b8b8b8', marginBottom: '2%' }),
    titleRow: Object.assign(Object.assign({}, commonStyles.flexRow), { marginBottom: '2%' }),
    title: {
        fontWeight: 'bold',
    },
    mainColumn: {
        width: '30%',
    },
    sizeColumn: {
        flex: 1,
    },
    sizeRow: Object.assign(Object.assign({}, commonStyles.flexRow), { marginBottom: '1%' }),
    sizeCell: {},
});
function VariantsPage({ variants, sizes, t }) {
    const rowSummaries = variants.map((variant) => ({
        name: variant.name,
        id: `${variant.id}_summary`,
        quantity: sizes.reduce((sum, size) => {
            const variantQuantity = variant.quantities.find((q) => { var _a; return (q === null || q === void 0 ? void 0 : q.isActive) && ((_a = q === null || q === void 0 ? void 0 : q.size) === null || _a === void 0 ? void 0 : _a.id) === size.id; });
            return sum + (variantQuantity ? variantQuantity.quantity : 0);
        }, 0),
    }));
    const columnSummaries = sizes
        .filter((s) => s.isActive)
        .map((size) => ({
        name: size.name,
        id: `${size.id}_summary`,
        quantity: variants.reduce((sum, v) => {
            const variantQuantity = v.quantities.find((q) => { var _a; return (q === null || q === void 0 ? void 0 : q.isActive) && ((_a = q === null || q === void 0 ? void 0 : q.size) === null || _a === void 0 ? void 0 : _a.id) === size.id; });
            return sum + (variantQuantity ? variantQuantity.quantity : 0);
        }, 0),
    }));
    return (React.createElement(View, { style: styles.elements },
        React.createElement(View, { style: styles.titleRow },
            React.createElement(View, { style: styles.mainColumn },
                React.createElement(Text, { style: styles.title }, t('model_variants_pieces'))),
            sizes
                .filter((s) => s.isActive)
                .map((size) => (React.createElement(View, { key: size.id, style: styles.sizeColumn },
                React.createElement(Text, null, size.name)))),
            React.createElement(View, { style: styles.sizeColumn },
                React.createElement(Text, null, t('common:summary')))),
        variants.map((variant, index) => {
            var _a;
            return (React.createElement(View, { key: variant.id, style: styles.sizeRow },
                React.createElement(View, { style: styles.mainColumn },
                    React.createElement(Text, null, variant.name)), (_a = variant === null || variant === void 0 ? void 0 : variant.quantities) === null || _a === void 0 ? void 0 :
                _a.map((variantQuantity, qIdx) => {
                    var _a, _b;
                    return variantQuantity &&
                        ((_a = sizes.find((size) => { var _a; return size.id === ((_a = variantQuantity.size) === null || _a === void 0 ? void 0 : _a.id); })) === null || _a === void 0 ? void 0 : _a.isActive) && (React.createElement(View, { key: (_b = variantQuantity.id) !== null && _b !== void 0 ? _b : qIdx, style: styles.sizeColumn },
                        React.createElement(Text, { style: styles.sizeCell }, variantQuantity.quantity)));
                }),
                React.createElement(View, { style: styles.sizeColumn },
                    React.createElement(Text, { style: styles.sizeCell }, rowSummaries.map((row) => row.quantity)[index]))));
        }),
        React.createElement(View, { style: styles.sizeRow },
            React.createElement(View, { style: styles.mainColumn },
                React.createElement(Text, null, t('common:summary'))),
            columnSummaries.map((columnSummary) => (React.createElement(View, { key: columnSummary.id, style: styles.sizeColumn },
                React.createElement(Text, { style: styles.sizeCell }, columnSummary.quantity)))),
            React.createElement(View, { style: styles.sizeColumn },
                React.createElement(Text, { style: styles.sizeCell }, columnSummaries.reduce((sum, col) => sum + col.quantity, 0))))));
}
export default withTranslation('specification')(memo(VariantsPage));
